// extracted by mini-css-extract-plugin
export default {"content":"SettingsContent_content__mvXHt"};